export default __webpack_public_path__ + "portal/static/media/User.10c45c7d.svg";